import { Leaf } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export function Footer() {
  return (
    <>
      {/* CTA Section */}
      <section className="relative px-4 py-24 sm:px-6 lg:px-8 overflow-hidden">
        <div className="pointer-events-none absolute inset-0 mesh-gradient" />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative mx-auto max-w-3xl text-center"
        >
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-foreground">
            Ready to take control of your{' '}
            <span className="text-gradient">productivity</span>?
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            Join hundreds of professionals who use Velora to stay organized and focused.
          </p>
          <div className="mt-8 flex justify-center gap-4">
            <Link
              to="/signup"
              className="inline-flex items-center gap-2 rounded-2xl gradient-primary px-8 py-3.5 text-base font-semibold text-white btn-glow shadow-lg shadow-primary/25 transition-all duration-300 hover:scale-[1.03]"
            >
              Get Started Free <Leaf className="h-4 w-4" />
            </Link>
          </div>
        </motion.div>
      </section>

      {/* Footer */}
      <footer className="border-t border-border/40 bg-card px-4 py-10 sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 sm:flex-row">
          <div className="flex items-center gap-2.5 font-display font-bold text-foreground">
            <div className="flex h-8 w-8 items-center justify-center rounded-xl gradient-primary shadow-glow">
              <Leaf className="h-4 w-4 text-white" />
            </div>
            Velora
          </div>
          <div className="flex items-center gap-4">
            <Link to="/changelog" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Changelog
            </Link>
            <span className="text-border">·</span>
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Velora
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}